module.exports = __webpack_public_path__ + "static/agre-adba0d6befec4aee99ca367ed4fff2ef.png";